import type { ReactNode } from "react";
import { AlertCircle, CheckCircle2, Clock3, FileQuestion } from "lucide-react";

export function StatusPill({
  status,
  children,
}: {
  status: "success" | "warning" | "danger" | "neutral";
  children: ReactNode;
}) {
  const Icon =
    status === "success"
      ? CheckCircle2
      : status === "warning"
        ? Clock3
        : status === "danger"
          ? AlertCircle
          : FileQuestion;
  return (
    <span className={`status-pill status-${status}`}>
      <Icon size={14} />
      {children}
    </span>
  );
}

export function EmptyState({
  icon,
  title,
  children,
  action,
}: {
  icon?: ReactNode;
  title: string;
  children: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="empty-state">
      <div className="empty-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{children}</p>
      {action}
    </div>
  );
}

export function Field({
  label,
  hint,
  children,
  wide = false,
}: {
  label: string;
  hint?: string;
  children: ReactNode;
  wide?: boolean;
}) {
  return (
    <label className={`field ${wide ? "field-wide" : ""}`}>
      <span>
        {label}
        {hint && <small>{hint}</small>}
      </span>
      {children}
    </label>
  );
}
